import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-bar-box"},[_c(VTextField,{staticClass:"search-bar",attrs:{"dense":"","label":"Rechercher","hide-details":"","type":"text","placeholder":_vm.placeholder,"prepend-inner-icon":"mdi-magnify"},on:{"change":function($event){return _vm.searchTextChanged()}},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }